import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IFetchWorkspacePracticeMinutesParams {
  days_ago?: number;
  include_top_workspace_check?: boolean;
  refetchInterval?: number;
}

export interface IFetchWorkspacePracticeMinutesResponse {
  practice_minutes: number;
  top_half_of_all_workspaces: boolean;
  top_third_of_all_workspaces: boolean;
}

export default function useFetchWorkspacePracticeMinutes({
  days_ago = 30,
  include_top_workspace_check = false,
  refetchInterval,
}: IFetchWorkspacePracticeMinutesParams): UseQueryResult<
  IFetchWorkspacePracticeMinutesResponse,
  unknown
> {
  const axios = useAxios();

  const query = useQuery<IFetchWorkspacePracticeMinutesResponse>(
    ["workspace-practice-minutes", { days_ago, include_top_workspace_check }],
    async (): Promise<IFetchWorkspacePracticeMinutesResponse> => {
      return await axios
        .get(`/v1/workspaces/practice-sets/sessions/practice-minutes`, {
          params: {
            days_ago,
            include_top_workspace_check,
          },
        })
        .then((r) => {
          return r.data as IFetchWorkspacePracticeMinutesResponse;
        });
    },
    { refetchInterval }
  );

  return query;
}
